import React from 'react';
import { useState, useEffect, useCallback, useRef } from 'react';

import t from '../Translation/Translation';
import { IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton, IonIcon, IonModal, IonList, IonLabel, IonItem, IonInput } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { Loader } from 'citric_components';
import Summary from '../Summary/Summary';
import {Button, Alert, Form, FloatingLabel, Accordion, Row, Col} from 'react-bootstrap';
import {lit, rit} from '../Util/IconText';

import { App } from '@capacitor/app';

import { Avatar, CustomTable } from 'citric_components';

import CardImg from '../../images/card.png';
import { useNavigate, useLocation } from 'react-router';

import conf from '../../config.json';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { generateKey } from '../Util/Util';
import { isCATI } from '../Releases/Releases';
import { logD } from '../Util/Util';

import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import moment from 'moment/min/moment-with-locales';
import { C } from 'sip.js/lib/core';
import Header from '../Dashboard/Header';

export default function Cati(props) {
    logD("Cati", props);

    const [interviewees, setInterviewees] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalOpenState, setModalOpenState] = useState(false);
    const [modalConfirmUnsubscribe, setModalConfirmUnsubscribe] = useState(false);
    const [selected, setSelected] = useState(null);
    const [selectedToUnsubscribe, setSelectedToUnsubscribe] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [events, setEvents] = useState([]);
    const [isAplazar, setIsAplazar] = useState(false);
    const [state, setState] = useState('OTRO');
    const [date, setDate] = useState(null);
    const [assign, setAssign] = useState(null);
    const [code, setCode] = useState("");
    const [number, setNumber] = useState(null);

    const modal = useRef(null);
    const input = useRef(null);

    //const [reload, setReload] = useState(props.reload);
    //const reload = props.reload;
    const launch = props.launch;
    var hiddenColumns = ['idInterviewed', 'idResponse'];

    const navigate =useNavigate();
    const location = useLocation();

    const summaryData = {};
    summaryData.id_form = props.launch.release ? props.launch.release.idDraft : -1;
    summaryData.plannings = [props.launch.idLaunch];
    summaryData.lang_code = "ES";

    moment.locale('es')
    console.log(moment.locale());
    console.log(moment().locale());
    const localizer = momentLocalizer(moment);

    function back() {
        
        //setResponses(null);
        //props.setLaunch(null);
        setTimeout(function(){
            navigate(-1);
        }, 1);
        //navigate.go(-1);
    }

    App.addListener('backButton', ({canGoBack}) => {
          
          if(!canGoBack){
            App.exitApp();
          } else {
            back();
          }
    });

    const changeCode = (e) => {
        setCode(e.target.value);
    }

    const changeNumber = (e) => {
        setNumber(e.target.value);
    }

    function setNewState(newState) {
        if(newState === 'APLAZAR') {
            setIsAplazar(true);
        } else {
            setIsAplazar(false);
            setDate(null);
        }
        setState(newState);
    }

    function confirm() {
        modal.current?.dismiss(input.current?.value, 'confirm');
    }

    async function onWillDismiss(event) {
        setModalOpenState(false);
        if (event.detail.role === 'confirm') {
            changeState(assign, state, event.detail.data, date);
        }
    }

    function openURLInNewTab(url) {
        //window.open(url, '_blank');
        console.log(url);
    }

    function showFollowup(item) {
        
        setSelected(item);
        setTimeout(function(){
            setModalOpen(true);
        }, 1);
    }

    function assignInterviewees() {
        let fd = new URLSearchParams();
        fd.append("idL", launch.idLaunch);
        fd.append("idU", props.interviewer);
        //const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/dash/all';
        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/assignInterviewees';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => props.handleError(response))
        //.then((response) => response.json())
        .then((data) => {
            logD("Cati", data);
            if(data && data != null) {
                if(data.textKey == "assign_interviewees") {
                    setInterviewees(null);
                    getIterviewees();
                }
                setAlertMsg(data.textKey);
                setShowAlert(true);
            } else {
                props.setShowToast(true);    
            }
            //setInterviewees(data);
        }).catch((e) => {
            props.setShowToast(true);
        });
    }

    function getIterviewees() {
        let fd = new URLSearchParams();
        fd.append("idL", launch.idLaunch);
        fd.append("idU", props.interviewer);

        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/allInterviewees';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => props.handleError(response))
        //.then((response) => response.json())
        .then((data) => {
            logD("Cati", data);
            var eventsInterviewees = [];
            for(var i in data) {
                var inter = data[i];
                if(inter.followup[0] && inter.followup[0].ddAcctionDto.codigo === 'APLAZAR') {
                    console.log(inter.cita);
                    console.log(new Date(inter.cita));
                    var event = {
                        id: inter.idInterviewed,
                        title: inter.name + ' ' + (inter.tlf ? inter.tlf : '') + ' ' + (inter.followup[0].texto != null ? inter.followup[0].texto : ''),
                        start: new Date(inter.followup[0].cita),
                        end: new Date(inter.followup[0].cita+1800000)
                    };
                    eventsInterviewees.push(event);
                }
            }
            console.log(eventsInterviewees);
            setEvents(eventsInterviewees);
            console.log(data);
            setInterviewees(data);
        }).catch((e) => {
            props.setShowToast(true);
        });
    }

    function nextInterviewed() {
        let fd = new URLSearchParams();
        fd.append("idU", props.interviewer);
        fd.append("idL", launch.idLaunch);
        fd.append("code", code);
        fd.append("number", number);

        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/nextInterviewed';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => props.handleError(response))
        //.then((response) => response.json())
        .then((data) => {
            logD("Cati", data);
            var load = false;
            if(data.idResponse == null && data.idInterviewed != null) {
                props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/e?elem=form&accion=empezar&planificacion=' + launch.idLaunch + '&usuario=' + data.idInterviewed + '&entrevistador=' + props.interviewer +'&origen=email');
                load = true;
            } else if(data.idResponse != null) {
                props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/e?elem=form&accion=cargar&planificacion=' + launch.idLaunch + '&cuestionario=' + data.idResponse + '&origen=email');
                load = true;
            }

            if(load) {
                if(launch.callType !== 'none' && number != null) {
                    window.location.href = launch.callType + ":" + number;
                }
                changeState(data.followup[0].idAsignacionGuiada, 'LLAMAR');
                props.setAssign(data.followup[0].idAsignacionGuiada);
                props.setTitle(launch.release.name + ' - ' + data.name + ' ' + (data.tlf ? data.tlf : ''));
                props.setTypeUrl('cati');
                setTimeout(function(){
                    navigate('../webview/'+(data.idResponse ? data.idResponse : 'new'));
                }, 100);
            }
        }).catch((e) => {
            props.setShowToast(true);
        });
    }

    function changeState(asign, code, note, date) {
        let fd = new URLSearchParams();
        fd.append("idL", launch.idLaunch);
        fd.append("idU", props.interviewer);
        fd.append("idA", asign);
        fd.append("code", code);
        if(note)
            fd.append("reason", note);
        if(date && date != null)
            fd.append("timestamp", Date.parse(date));

        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/changeState';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => props.handleError(response))
        //.then((response) => response.json())
        .then((data) => {
            logD("Cati", data);
            setInterviewees(null);
            getIterviewees();
            //setInterviewees(data);
        }).catch((e) => {
            props.setShowToast(true);
        });
    }

    useEffect(() => {
        if(launch != null) {
            getIterviewees();
        }
    }, []);

    const columns = [
        {
            Header: t('id'),
            accessor: 'idInterviewed',
        },
        {
            Header: t('idResponse'),
            accessor: 'idResponse',
        },
        {
            Header: t('actions'),
            id: 'actions',
            accessor: (d) => {
                if(d.followup && d.followup != null && d.followup.length > 0 && d.followup[0].ddAcctionDto.id != 12) {
                    return <>
                    {(d.stateResponse == 1 || d.stateResponse == null) && <IonButton onClick={ (e) => { 
                        if(launch.callType !== 'none' && d.tlf != null) {
                            window.location.href = launch.callType + ":" + d.tlf;
                        }
                        e.preventDefault();
                        //props.setLaunch(launch);
                        //setResponses(null);
                        //props.setReload(true);
                        if(d.idResponse === null) {
                            props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/e?elem=form&accion=empezar&planificacion=' + launch.idLaunch + '&usuario=' + d.idInterviewed + '&entrevistador=' + props.interviewer +'&origen=email');
                        } else {
                            props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/e?elem=form&accion=cargar&planificacion=' + launch.idLaunch + '&cuestionario=' + d.idResponse + '&origen=email');
                        }

                        changeState(d.followup[0].idAsignacionGuiada, 'LLAMAR');
                        props.setAssign(d.followup[0].idAsignacionGuiada);

                        props.setTitle(launch.release.name + ' - ' + d.name + ' ' + (d.tlf ? d.tlf : ''));
                        props.setTypeUrl('cati');
                        setTimeout(function(){
                            navigate('../webview/'+(d.idResponse ? d.idResponse : 'new'));
                        }, 100);
                        //var url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/answer/e?elem=form&accion=cargar&planificacion=' + launch.idLaunch + '&cuestionario=' + d.idResponse + '&origen=portalEncuestaMod';
                        //InAppBrowser.create(url, "_self", {});
                        //openURLInNewTab(conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/answer/e?elec=form&accion=cargar&planifciacion=' + launch.idLaunch + '&cuestionario=' + d.idResponse + '&origen=portalEncuesta');
                    }}>{t('call')}</IonButton>}
                    <IonButton onClick={ (e) => { 
                        e.preventDefault();
                        setAssign(d.followup[0].idAsignacionGuiada);
                        setModalOpenState(true);
                    }}>{t('edit')}</IonButton>
                    <IonButton onClick={ (e) => { 
                        e.preventDefault();
                        setSelectedToUnsubscribe(d);
                        setModalConfirmUnsubscribe(true);
                    }}>{t('unsubscribe')}</IonButton>
                    </>
                }
            }
        },
        {
            id: 'interviewed',
            Header: t('interviewed'),
            accessor: (d) => {
                    return d.name + ' ' + (d.tlf ? d.tlf : '');
            }
        },
        {
            id: 'last_update',
            Header: t('last_update'),
            sortType: (a, b) => {
                if(b.original.followup && b.original.followup != null && b.original.followup.length > 0 && a.original.followup && a.original.followup != null && a.original.followup.length > 0) {
                    return a.original.followup[0].tmpcreacion - b.original.followup[0].tmpcreacion;
                }
            },
            accessor: (d) => {
                if(d.followup && d.followup != null && d.followup.length > 0) {
                    return new Date(d.followup[0].tmpcreacion).toLocaleString(navigator.language)
                }
            },

        },
        {
            id: 'state',
            Header: t('state'),
            accessor: (d) => {
                if(d.followup && d.followup != null && d.followup.length > 0) {
                    //return <span>{t(d.followup[0].ddAcctionDto.codigo.toLowerCase())} {d.followup[0].cita != null ? new Date(d.followup[0].cita).toLocaleString(navigator.language) : ''}</span>
                    return t(d.followup[0].ddAcctionDto.codigo.toLowerCase()) + ' ' + (d.followup[0].cita != null ? new Date(d.followup[0].cita).toLocaleString(navigator.language) : '');
                }

            }
        },
        {
            id: 'note',
            Header: t('note'),
            accessor: (d) => {
                if(d.followup && d.followup != null && d.followup.length > 0) {
                    return d.followup[0].texto != null ? d.followup[0].texto : '';
                }

            }
        },
        {
            id: 'followup',
            Header: t('followup'),
            accessor: (d) => {
                if(d.followup && d.followup != null && d.followup.length > 0) {
                    return <Button variant="link"><FontAwesomeIcon icon={faEye} onClick={() => showFollowup(d)}/></Button>;
                }

            }
        }
    ];

    const handleSelectEvent = useCallback((event) => {
            var globalFilter = document.getElementsByName("globalFilter");
            if(globalFilter.length > 0) {
                globalFilter[0].value = event.id;

                const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
                    window.HTMLInputElement.prototype,
                    'value').set;
                    nativeInputValueSetter.call(globalFilter[0], event.id);
                const eventInput = new Event('input', { bubbles: true });
                globalFilter[0].dispatchEvent(eventInput);
            }
    },[]);

    return (
        <> 
            <IonPage id="cati">
                <IonHeader>
                    <Header lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken}/>
                    <IonToolbar className="toolbar-azul">
                        <IonButtons slot="start">
                            <IonButton onClick={() => back()}><IonIcon icon={arrowBack}></IonIcon></IonButton>
                        </IonButtons>
                        <IonTitle>{launch.release ? launch.release.name : 'ERROR'}</IonTitle>
                        <IonButtons slot="end">
                            {launch.hasUsers && <IonButton onClick={ (e) => { 
                                    e.preventDefault();
                                    assignInterviewees();
                                }
                            }>
                                {t('more_interviewees')}
                            </IonButton>}
                            {!launch.hasUsers && <Form.Group className="py-3" controlId="code">
                                <FloatingLabel
                                    controlId="code"
                                    label={lit('alias')}
                                >
                                    <Form.Control name="code" placeholder={lit('alias')} onChange={(e) => changeCode(e)}/>
                                </FloatingLabel>
                            </Form.Group>}
                            {launch.callType !== 'none' && <Form.Group className="py-3" controlId="number">
                                <FloatingLabel
                                    controlId="number"
                                    label={lit('number')}
                                >
                                    <Form.Control name="number" placeholder={lit('number')} onChange={(e) => changeNumber(e)}/>
                                </FloatingLabel>
                            </Form.Group>}
                            <IonButton onClick={ (e) => { 
                                    e.preventDefault();
                                    if(!launch.hasUsers && code != null && code !== "") {
                                        // Validar que existe entrevistado con este code (name) y/o number (tlf)
                                        let found = false;
                                        if(interviewees) {
                                            for(let i = 0; i < interviewees.length; i++) {
                                                const inter = interviewees[i];
                                                if((inter.name && inter.name === code) || (inter.tlf && number != null && inter.tlf === number)) {
                                                    found = true;
                                                    break;
                                                }
                                            }
                                        }
                                        if(!found) {
                                            nextInterviewed();
                                        } else {
                                            setAlertMsg('exists_name_number');
                                            setShowAlert(true);
                                        }
                                    } else if(launch.hasUsers) { 
                                        nextInterviewed();
                                    }else {
                                        setAlertMsg('empty_name');
                                        setShowAlert(true);
                                    }
                                }
                            }>
                                {launch.hasUsers && t('next_interviewed')}
                                {!launch.hasUsers && t('new_interviewed')}
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    {   showAlert &&
                        <Alert key="success" variant="success" onClose={() => setShowAlert(false)} dismissible>
                            {t(alertMsg)}
                        </Alert>
                    }
                    {/*responses != null && <Summary data={summaryData} lang={"ES"} loi={false} handleError={props.handleError}/>*/}
                    {console.log(interviewees)}
                    {interviewees == null && <Loader />}
                    {
                        interviewees != null &&
                        <>
                            <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        {lit('calendar')}
                                        {events.length > 0 && <span className="badge bg-secondary ms-2">{events.length}</span>}
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="mb-3">
                                            <h5>{t('upcoming_events')}</h5>
                                        </div>
                                        <div className="d-flex overflow-auto mb-3" style={{ gap: '1rem' }}>
                                            {events.length === 0 ? (
                                                <div>{t('no_events')}</div>
                                            ) : (
                                                events.slice(0, 10).map((event) => (
                                                    <div key={event.id} className="border rounded p-2 mb-3" style={{ minWidth: '240px', flex: '0 0 auto', cursor: 'pointer' }} onClick={() => handleSelectEvent(event)}>
                                                        <div className="fw-bold">{event.title}</div>
                                                        <div>{new Date(event.start).toLocaleString(navigator.language)} - {new Date(event.end).toLocaleTimeString(navigator.language)}</div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                        <Calendar
                                            localizer={localizer}
                                            events={events}
                                            startAccessor="start"
                                            endAccessor="end"
                                            defaultView={Views.WEEK}
                                            onSelectEvent={handleSelectEvent}
                                            style={{ height: 500 }}
                                        />
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                            <CustomTable keyField='last_update' desc={true} data={interviewees} columns={columns} isFilter={true} isPagination={false} isSelection={false} hasActions={false} hiddenColumns={hiddenColumns} />
                        </>
                    }
                    <IonModal isOpen={modalOpen}>
                        <IonHeader>
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton onClick={() => setModalOpen(false)}>{t('close')}</IonButton>
                                </IonButtons>
                                <IonTitle>{selected != null ? selected.name + ' ' + (selected.tlf ? selected.tlf : '') : ''}</IonTitle>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            <IonList>
                            {
                                selected != null && selected.followup.map(function(item) {
                                    return <IonItem>
                                                <IonLabel>{new Date(item.tmpcreacion).toLocaleString(navigator.language)}</IonLabel>
                                                <IonLabel>{t(item.ddAcctionDto.codigo.toLowerCase())} {item.cita != null ? new Date(item.cita).toLocaleString(navigator.language) : ''}</IonLabel><br/>
                                                <IonLabel>{item.texto != null ? item.texto : ''}</IonLabel>
                                            </IonItem>
                                })
                            }
                            </IonList>
                        </IonContent>
                    </IonModal>
                    <IonModal ref={modal} isOpen={modalOpenState} onWillDismiss={(event) => onWillDismiss(event)}>
                        <IonHeader>
                            <IonToolbar>
                            <IonButtons slot="start">
                                <IonButton onClick={() => modal.current?.dismiss()}>{t('cancel')}</IonButton>
                            </IonButtons>
                            <IonTitle>{t('change_state')}</IonTitle>
                            <IonButtons slot="end">
                                <IonButton strong={true} onClick={() => confirm()}>
                                    {t('confirm')}
                                </IonButton>
                            </IonButtons>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            <>
                                <>
                                    <Row>
                                        <Col>
                                        <Form.Check
                                            inline
                                            label={t('FIN_ENTREVISTA')}
                                            name="group1"
                                            type="radio"
                                            id='FIN_ENTREVISTA'
                                            onClick={() => setNewState('FIN_ENTREVISTA')}
                                        />
                                        </Col>
                                        <Col>
                                        <Form.Check
                                            inline
                                            label={t('NO_CONTINUA')}
                                            name="group1"
                                            type="radio"
                                            id='NO_CONTINUA'
                                            onClick={() => setNewState('NO_CONTINUA')}
                                        />
                                        </Col>
                                        <Col>
                                        <Form.Check
                                            inline
                                            label={t('NO_CONTESTA')}
                                            name="group1"
                                            type="radio"
                                            id='NO_CONTESTA'
                                            onClick={() => setNewState('NO_CONTESTA')}
                                        />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Check
                                                inline
                                                label={t('ERROR_FAX')}
                                                name="group1"
                                                type="radio"
                                                id='ERROR_FAX'
                                                onClick={() => setNewState('ERROR_FAX')}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Check
                                                inline
                                                label={t('ERROR_TLF')}
                                                name="group1"
                                                type="radio"
                                                id='ERROR_TLF'
                                                onClick={() => setNewState('ERROR_TLF')}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Check
                                                inline
                                                label={t('ERROR_TLF_INC')}
                                                name="group1"
                                                type="radio"
                                                id='ERROR_TLF_INC'
                                                onClick={() => setNewState('ERROR_TLF_INC')}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Check
                                                inline
                                                label={t('APLAZAR')}
                                                name="group1"
                                                type="radio"
                                                id='APLAZAR'
                                                onClick={() => setNewState('APLAZAR')}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Check
                                                inline
                                                label={t('OTROS')}
                                                name="group1"
                                                type="radio"
                                                id='OTROS'
                                                onClick={() => setNewState('OTROS')}
                                            />
                                        </Col>
                                        <Col>
                                        </Col>
                                    </Row>
                                </>
                            {
                                isAplazar &&
                                <input className="mt-3" type="datetime-local" id="dateAplazar" name="dateAplazar" 
                                    onChange={e => setDate(e.target.value)}
                                    min={Date.now()}/>
                            }
                            <IonInput
                                label={t('add_note')}
                                labelPlacement="stacked"
                                ref={input}
                                type="text"
                                placeholder={t('note')}
                                className="mt-3"
                            />
                            </>
                        </IonContent>
                    </IonModal>
                    <IonModal isOpen={modalConfirmUnsubscribe} onDidDismiss={() => setModalConfirmUnsubscribe(false)}>
                        <IonHeader>
                            <IonToolbar>
                                <IonTitle>{t('confirm')}</IonTitle>
                                <IonButtons slot="end">
                                    <IonButton onClick={() => setModalConfirmUnsubscribe(false)}>{t('cancel')}</IonButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            <div>
                                <p>{t('confirm_unsubscribe')}</p>
                                {selectedToUnsubscribe && (
                                    <div className="mb-3 p-3 alert alert-info">
                                        <strong>{selectedToUnsubscribe.name}</strong> - {selectedToUnsubscribe.tlf}
                                    </div>
                                )}
                                <div className="d-flex gap-2">
                                    <Button variant="danger" className="flex-grow-1" onClick={() => {
                                        if(selectedToUnsubscribe && selectedToUnsubscribe.followup && selectedToUnsubscribe.followup.length > 0) {
                                            changeState(selectedToUnsubscribe.followup[0].idAsignacionGuiada, 'DAR_BAJA');
                                        }
                                        setModalConfirmUnsubscribe(false);
                                    }}>
                                        {t('confirm')}
                                    </Button>
                                    <Button className="flex-grow-1" onClick={() => setModalConfirmUnsubscribe(false)}>
                                        {t('cancel')}
                                    </Button>
                                </div>
                            </div>
                        </IonContent>
                    </IonModal>
                </IonContent>
            </IonPage>
        </>
    );
}